<template>
    <li>
        <button
            @click.prevent="deleteTray(tray.name)"
            :disabled="isLoading"
            class="disabled:opacity-50 disabled:pointer-events-none bg-v2-white border border-v2-white flex font-medium gap-3 items-center leading-none max-w-full p-3 relative rounded text-v2-red text-left text-xs w-full hover:border-v2-gray-70 dark:bg-v2-gray-65 dark:border-v2-gray-10 hover:dark:border-v2-gray-90">
            <LoadingCircle v-if="isLoading" />
            <BaseSvg v-else name="TrashCan" aria-hidden="true" class="size-4"/>
            Delete Tray
        </button>
    </li>
</template>

<script setup>
import {usePinsDrawer} from "@/Composables";
import {LoadingCircle} from "@/Components";

const props = defineProps(['tray']);

const { deleteTray, isLoading } = usePinsDrawer();
</script>
